export const getRoutes = (mountElementId: string) => {
    const mountElement = document.getElementById(mountElementId);
    return {
        storiesRoute:
            mountElement?.getAttribute("data-stories-route") || "stories",
        playlistsRoute:
            mountElement?.getAttribute("data-playlists-route") || "playlists-overview",
        toursRoute: 
            mountElement?.getAttribute("data-tours-route") || "tours",
    };
};
